import React from 'react';

const Blocked = ({content}) =>
    <div id="MEDICAL_RX_BLOCKED_CONTAINER" className="billboard">{content}</div>;

export default Blocked;
